import { makeObservable, observable, action, reaction,computed } from 'mobx';
import axios, { storeGet } from "../utils/axios";
import historyVars from "../utils/historyVars";
import errors from "../reducers/errors";

import configStore from "./data_loaders/configStore";
import dataStore from "./data_loaders/dataStore";
import memoryStore from "./data_loaders/memoryStore";
import searchStore from "./data_loaders/searchStore";
import filter from "../utils/filter";
import { history } from "../history_mobx";

import Item from "../components/Blog/Item";
import ItemMedium from "../components/Blog/ItemMedium";
import ItemSmall from "../components/Blog/ItemSmall";
import configMerge from "../utils/configMerge";

class photoStore {
  config={
    sorter:[],
    view_mode:"medium",
    show_view_chooser:true,
    // title:this.par.stores.translateStore.photo.title,
    modes:{
      medium:{ component:"FigureItem", wrap_class:"up12 margin s-size-1 m-size-2 h-size-3" },
      small:{ component:"FigureItemSmall", wrap_class:"up12 margin s-size-4 m-size-6 h-size-8 xl-size-10" },
      big:{ component:"FigureItemBig", wrap_class:"up12 margin s-size-2 m-size-3 h-size-3 xl-size-4" },
      // medium:{ component:"BlogItemMedium", wrap_class:"up12 margin s-size-1 m-size-2 h-size-2", },
      // small:{ component:"BlogItemSmall", wrap_class:"up12 margin s-size-4 m-size-9 h-size-11", }
    }
  }
  constructor(par,config) {
    this.par=par;
    this.configStore=new configStore(this);
    this.memoryStore=new memoryStore(this, config.disable_memory?true:false );
    this.searchStore=new searchStore(this);
    this.dataStore=new dataStore(this);

    const t=par.stores.translateStore.t.photo;
    const fig=par.stores.translateStore.t.figure;

    const tableConfig={
      layout:[],
      layout_marker: "figure_store",
      default_filter:"name",
      disable_str_mask:true,
      default_order:{"release_date":"desc"},
      data_route:"/api/figure",
      pathname_only:history.location.pathname,
      system_filter:config.filter || null,
      fields:[
        filter.string({ name: fig.NAME, code:'name' }),
        filter.full_list({code: "property_figure_type", name: t.FIGURE_TYPE, }),
        filter.full_list({code: "property_manufacturer", name: fig.MANUFACTURER, list_route:'/sysapi/local_list/figure_manufaturer' }),
        filter.string({ name: fig.ORIGINAL, code:'original_name' }),
        /*filter.string({ name: fig.ANIME, code:'anime_id' }),*/
        filter.string({ name: fig.CHAR_NAME, code:'character_name' }),
        filter.string({ name: fig.SCULPTOR, code:'property_sculptor' }),
        filter.string({ name: fig.MATERIAL, code:'property_material' }),
        filter.full_list({ name: fig.SCALE, code:'property_size', list_route:'/sysapi/local_list/figure_scale' }),
        filter.string({ name: fig.SERIES, code:'sect_name' }),
        filter.yes_no({ name: '18+', code:'property_porno' }),
        filter.yes_no({ name: fig.DRAFT, code:'property_porno' }),
        filter.integer({ name: 'ID', code:'id' }),

      ]
    };

    if(!config) {
      config={};
    }




    /*
    { name: t.FIGURE_NAME, code:'cacher__text__figures', type:'text' },
    { name: t.CHARACTER, code:'cacher__text__characters', type:'text' },
    { name: t.ORIGINAL, code:'cacher__text__original', type:'text' },
    { name: t.FIGURE_TYPE, code:'figure_type_text', type:'ajax_select', get_url:'/api/figure/types' },
    { name: t.PUBLISH_TYPE, code:'public', type:'select', options:{'figures':'only figures','albums':'only public folders','figures_and_albums':'figures and folders'} },
    { name: t.UPLOADED, code:'upload_time', type:'select', options:optionsUploaded },
    */
    makeObservable(this, {
      config: observable,
      view_mode: computed,
    });

    this.prepareConfig();

    this.configStore.setConfig(tableConfig);
    configMerge(config,tableConfig,this.config);

  }
  get view_mode() {
    return this.config.modes[this.config.view_mode];
  }
  prepareConfig() {
    const ord = this.par.stores.translateStore.t.order;
    const fig = this.par.stores.translateStore.t.figure;
    // this.config.title=this.par.stores.translateStore.t.photo.SPOT_TITLE;
    this.config.title="Фигурки";

    this.config.sorter=[
      {name: `${ord.DATE_A} ${fig.RELEASE_DATE_2}`, code: 'release_date', start: 'desc' },

      {name: ord.RATING, code: 'rating_mark', start: 'desc' },
      {name: ord.COMMENTS, code: 'c_comments_value', start: 'desc' },
      {name: fig.FIGURE_TYPE, code: 'figure_type_name', start: 'asc' },
      {name: fig.MANUFACTURER, code: 'manufacturer_name', start: 'asc'},
      {name: fig.OWNERS, code: 'owners_value', start: 'asc' },
      {name: this.par.stores.translateStore.t.titles.COMMENTS, code: 'c_comments_value', start: 'asc' },

      {name: ord.DATE_ADDED2, code: 'id', start: 'desc' },
      {name: `${ord.DATE_A} ${ord.DATE_MODIFY}`, code: 'modified_time', start: 'desc' },
    ];
  }
  destroy() {
    const arr=[this.memoryStore];
    for(let i in arr) {
      arr[i].destroy();
    }
  }
  getStores() {
    return {
      configStore: this.configStore,
      dataStore: this.dataStore,
      memoryStore: this.memoryStore,
      searchStore: this.searchStore,
      dataCombiner: this,
    }
  }
  /*fetchMe() {
    storeGet(`/api/user/me`, this.me);
  }*/

}


export default photoStore;
